import { render, staticRenderFns } from "./ChatTemplatesCategories.vue?vue&type=template&id=261edd52&scoped=true"
import script from "./ChatTemplatesCategories.vue?vue&type=script&lang=js"
export * from "./ChatTemplatesCategories.vue?vue&type=script&lang=js"
import style0 from "./ChatTemplatesCategories.vue?vue&type=style&index=0&id=261edd52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "261edd52",
  null
  
)

export default component.exports